module.exports = __webpack_public_path__ + "static/media/16_inch_Cash_Drawer_White_w_o_BO_large_eaa6c21d-4bc7-4137-8c2d-bafef797be56_1200x1200.5130132a.webp";